import { render, staticRenderFns } from "./SkillsGraphics.vue?vue&type=template&id=0392db82&scoped=true&"
import script from "./SkillsGraphics.vue?vue&type=script&lang=js&"
export * from "./SkillsGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392db82",
  null
  
)

export default component.exports